import './AppRoot.css';
export var dtVisualRefreshEnabled = '_1jgl8s50-3-5-0';